import {default as Base} from "parent/ts/store/Main";
import Initializer from "~/ts/Components/Blocks/Initializer";

class Main extends Base {

    initializeBlocks(): Initializer {
        return new Initializer();
    }
}

export default Main;
